document.addEventListener("DOMContentLoaded", function() {
  var videoPlayer = document.getElementById("article-video-player");
  var articleIdElement = document.getElementById("article-id");

  // Garde indispensable : ces deux éléments n'existent que sur un coup de projecteur
  // porteur d'une vidéo. Sans elle, `articleIdElement.textContent` levait une
  // TypeError sur TOUTES les autres pages, ce qui interrompait ce gestionnaire —
  // et donc tout code ajouté à sa suite.
  if (!videoPlayer) return;

  // --- Compteur de lectures (comportement existant, inchangé) -----------------
  if (articleIdElement) {
    var articleId = articleIdElement.textContent.trim();
    videoPlayer.addEventListener("play", function() {
      fetch("/articles/" + articleId + "/increment_view", {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      })
      .then(function(response) {
        if (!response.ok) { console.error("Failed to increment view count."); }
      })
      .catch(function(error) { console.error(error); });
    });
  }

  // --- Pastille « play » sur la vidéo (planche 3) -----------------------------
  // Amélioration progressive : le gabarit sert un lecteur natif complet, avec ses
  // contrôles. Ce n'est QUE si le script s'exécute qu'on les masque au profit de la
  // pastille. Sans JavaScript, la vidéo reste donc lisible normalement.
  var overlay = document.querySelector(".video-play");
  if (!overlay) return;

  videoPlayer.removeAttribute("controls");
  overlay.hidden = false;

  overlay.addEventListener("click", function() {
    overlay.hidden = true;
    videoPlayer.setAttribute("controls", "controls");
    videoPlayer.play();   // déclenche l'événement "play", donc le compteur ci-dessus
  });

  // Si la lecture démarre autrement (clavier, contrôles rendus visibles), la pastille
  // ne doit pas rester affichée par-dessus.
  videoPlayer.addEventListener("play", function() {
    overlay.hidden = true;
    videoPlayer.setAttribute("controls", "controls");
  });
});
